var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-area"},[_c('img',{attrs:{"src":"loading_characters.gif","width":"360"}}),_c('p',{staticClass:"large-bold-text card-text text-area"},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }